import { AbiItem } from "web3-utils";

// The ERC-20 Contract ABI, which is a common contract interface
// for tokens (this is the Human-Readable ABI format)
export const SKRT_STAKING_ABI_0x7E269c080144Da40F907a0FA88d199904fF723DC: AbiItem[] = [
  {
    inputs: [
      { internalType: "address", name: "_tokenAddress", type: "address" },
      {
        internalType: "address",
        name: "_skrtVerificationAddress",
        type: "address",
      },
      {
        components: [
          { internalType: "uint256", name: "stakingPoolSize", type: "uint256" },
          {
            internalType: "uint256",
            name: "minimumStakingAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maximumStakingAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stakingPeriodSeconds",
            type: "uint256",
          },
        ],
        internalType: "struct SkrtStaking.StakingParameters",
        name: "_stakingParameters",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "firstPenaltyPeriodSeconds",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "firstUnStakePenalty",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "secondUnStakePenalty",
            type: "uint256",
          },
        ],
        internalType: "struct SkrtStaking.StakingPenalties",
        name: "_stakingPenalties",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "annualMintPercentage",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "annualAdopterMintPercentage",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "annualInsiderMintPercentage",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "annualEvangelistMintPercentage",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "annualPartnerMintPercentage",
            type: "uint256",
          },
        ],
        internalType: "struct SkrtStaking.RewardPercentage",
        name: "_rewardPercentage",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "_unStakeStartSeconds",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_withdrawStartSeconds",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "_stakeTimestamp",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_whom",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "Lock",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "_stakeClaimedTimestamp",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_whom",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "StakeClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "_timestamp",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "TotalStakedTokens",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "_unstakeTimestamp",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_whom",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_rewards",
        type: "uint256",
      },
    ],
    name: "Unlock",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "_withdrawTimestamp",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_whom",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    inputs: [],
    name: "allowStaking",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_whom", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "claimRewards",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimRewardsAndStake",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_whom", type: "address" }],
    name: "getOnlyRewards",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getStakingTimeline",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "timestamp", type: "uint256" },
          { internalType: "uint256", name: "amount", type: "uint256" },
        ],
        internalType: "struct SkrtStaking.StakedTokensTimeline[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "index", type: "uint256" }],
    name: "getStakingTimelineItem",
    outputs: [
      { internalType: "uint256", name: "", type: "uint256" },
      { internalType: "uint256", name: "", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getStakingTimelineLength",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "lastStakeClaimed",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "numberOfStakers",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_address", type: "address" }],
    name: "resetStakingBalance",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardPercentage",
    outputs: [
      {
        internalType: "uint256",
        name: "annualMintPercentage",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "annualAdopterMintPercentage",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "annualInsiderMintPercentage",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "annualEvangelistMintPercentage",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "annualPartnerMintPercentage",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bool", name: "_allowStaking", type: "bool" }],
    name: "setAllowStaking",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "annualMintPercentage",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "annualAdopterMintPercentage",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "annualInsiderMintPercentage",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "annualEvangelistMintPercentage",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "annualPartnerMintPercentage",
            type: "uint256",
          },
        ],
        internalType: "struct SkrtStaking.RewardPercentage",
        name: "_rewardPercentage",
        type: "tuple",
      },
    ],
    name: "setRewardPercentage",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_address", type: "address" }],
    name: "setSkrtVerificationAddress",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          { internalType: "uint256", name: "stakingPoolSize", type: "uint256" },
          {
            internalType: "uint256",
            name: "minimumStakingAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maximumStakingAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "stakingPeriodSeconds",
            type: "uint256",
          },
        ],
        internalType: "struct SkrtStaking.StakingParameters",
        name: "_stakingParameters",
        type: "tuple",
      },
    ],
    name: "setStakingParameters",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "firstPenaltyPeriodSeconds",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "firstUnStakePenalty",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "secondUnStakePenalty",
            type: "uint256",
          },
        ],
        internalType: "struct SkrtStaking.StakingPenalties",
        name: "_stakingPenalties",
        type: "tuple",
      },
    ],
    name: "setStakingPenalties",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_tokenAddress", type: "address" },
    ],
    name: "setTokenAddress",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_unStakeStartSeconds",
        type: "uint256",
      },
    ],
    name: "setUnStakeStartSeconds",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "bool", name: "_verifyAddress", type: "bool" }],
    name: "setVerifyAddress",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_withdrawStartSeconds",
        type: "uint256",
      },
    ],
    name: "setWithdrawStartSeconds",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "skrtAddressVerification",
    outputs: [
      {
        internalType: "contract ISkrtAddressVerification",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "skrtVerificationAddress",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_amount", type: "uint256" }],
    name: "stake",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "stakeBalance",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stakingParameters",
    outputs: [
      { internalType: "uint256", name: "stakingPoolSize", type: "uint256" },
      {
        internalType: "uint256",
        name: "minimumStakingAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maximumStakingAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stakingPeriodSeconds",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stakingPenalties",
    outputs: [
      {
        internalType: "uint256",
        name: "firstPenaltyPeriodSeconds",
        type: "uint256",
      },
      { internalType: "uint256", name: "firstUnStakePenalty", type: "uint256" },
      {
        internalType: "uint256",
        name: "secondUnStakePenalty",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "stakingTimeline",
    outputs: [
      { internalType: "uint256", name: "timestamp", type: "uint256" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "token",
    outputs: [{ internalType: "contract IERC20", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenAddress",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalClaimedRewards",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalStakedTokens",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_amount", type: "uint256" }],
    name: "transferTokens",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unStake",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unStakeStartSeconds",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "verifyAddress",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawStartSeconds",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_amount", type: "uint256" }],
    name: "withdrawTokens",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function",
  },
];
